import { CHEONGNYANGNI_PRIORITY_STORE_CODES, CHEONGNYANGNI_SHOPPING_MALL_MAP_ID } from '@/constants/parking';
import type { BuildingInStoreInfo, BuildingInfo } from '@/services/dto';
import type { PoiContentSlide } from '@/types/shop';

export type KioskPriorityBuilding = {
    storeCode: string;
    buildingCode: string;
};

const isCheongnyangniPriorityStoreCode = (storeCode?: string | null): boolean =>
    !!storeCode && (CHEONGNYANGNI_PRIORITY_STORE_CODES as readonly string[]).includes(storeCode);

const findKioskStoreBuilding = (
    buildings: BuildingInStoreInfo[] | undefined,
    kioskBuilding: BuildingInfo | undefined,
): BuildingInStoreInfo | undefined => {
    if (!buildings?.length || !kioskBuilding) return undefined;

    const byId = buildings.find((building) => building.id === kioskBuilding.id);
    if (byId) return byId;

    const byCode = buildings.filter((building) => building.buildingCode === kioskBuilding.buildingCode);
    return byCode.length === 1 ? byCode[0] : undefined;
};

export const resolveKioskPriorityBuilding = (
    mapId: string | undefined,
    kioskBuilding: BuildingInfo | undefined,
    buildings: BuildingInStoreInfo[] | undefined,
): KioskPriorityBuilding | null => {
    if (mapId !== CHEONGNYANGNI_SHOPPING_MALL_MAP_ID) return null;

    const building = findKioskStoreBuilding(buildings, kioskBuilding);
    if (!building || !isCheongnyangniPriorityStoreCode(building.storeCode)) return null;

    return {
        storeCode: building.storeCode,
        buildingCode: building.buildingCode,
    };
};

const matchesPriorityBuilding = (item: PoiContentSlide, priority: KioskPriorityBuilding): boolean => {
    const storeCode = item.data.contents?.cstrCd?.ko;
    const buildingCode = item.data.contents?.cstrTownCd?.ko;
    if (storeCode !== priority.storeCode) return false;
    if (!priority.buildingCode) return true;
    return buildingCode === priority.buildingCode;
};

export const compareByKioskBuilding = (a: PoiContentSlide, b: PoiContentSlide, priority: KioskPriorityBuilding | null): number => {
    if (!priority) return 0;
    const aRank = matchesPriorityBuilding(a, priority) ? 0 : 1;
    const bRank = matchesPriorityBuilding(b, priority) ? 0 : 1;
    return aRank - bRank;
};
